<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ getMessage_('SWCC000341') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" :placeholder="getMessage_('SWCC000341')" @change="change">
				<el-option label="ALL" value="ALL"></el-option>
				<el-option v-for="(msgLoc, index) in msgLocs" :label="msgLoc.commCdName" :value="msgLoc.commCd" :key="index"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/DicMsgManagement/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'msgLoc', value: value }).then(() => {
				this.$emit('reload', 1, 10);
			});
		}
	},
	created() {
		if (this.searchParams.msgLoc == null) {
			this.searchParams.msgLoc = 'ALL';
		}
		this.data = this.searchParams.msgLoc;
	}
};
</script>

<style></style>
